(function () {

function initFlakeShopFilter() {
  const shop = document.querySelector('[data-flake-shop]');
  const drawer = document.querySelector('[data-filter-drawer]');
  const overlay = document.querySelector('[data-filter-overlay]');

  if (!shop || shop.dataset.flakeShopInitialized === 'true') return;

  shop.dataset.flakeShopInitialized = 'true';
  const availabilityParam = shop.dataset.flakeAvailabilityParam || 'filter.p.m.custom.flake_fulfillment';
  const defaultSort = shop.dataset.flakeDefaultSort || 'manual';
  const typeParam = shop.dataset.flakeTypeParam || 'filter.p.m.custom.flake_type';

  let syncTimer = null;
  let loadingFallbackTimer = null;
  let resultsCopyRequest = 0;
  let collectionSwitchRequest = 0;
  let renderedCollectionPath = window.location.pathname;
  let isSwitchingCollection = false;


  /* =========================================================
     NATIVE SHOPIFY FACET BRIDGE

     The theme already renders a hidden <facet-form> that handles
     Search & Discovery filtering with AJAX. Our custom controls
     mirror/toggle those native inputs rather than navigating away.
  ========================================================= */

  function getNativeForm() {
    return document.querySelector('#FacetFiltersContainer form[is="facet-form"], #FacetFiltersContainer form.face-form');
  }


  function getParams() {
    return new URLSearchParams(window.location.search);
  }


  function fallbackNavigate(params) {
    params.delete('page');

    const query = params.toString();

    window.location.href =
      window.location.pathname + (query ? '?' + query : '');
  }


  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/(["\\#.;?+*~':!^$\[\]()=>|/@])/g, '\\$1');
  }


  function findNativeInput(param, value) {
    const form = getNativeForm();
    if (!form) return null;

    return Array.from(form.elements).find(function(input) {
      return input.name === param && input.value === value;
    }) || null;
  }


  function ensureNativeCheckbox(param, value) {
    const form = getNativeForm();
    if (!form) return null;

    let input = findNativeInput(param, value);

    if (!input) {
      input = document.createElement('input');
      input.type = 'checkbox';
      input.name = param;
      input.value = value;
      input.hidden = true;
      input.dataset.flakeBridge = 'true';
      form.appendChild(input);
    }

    // The fulfillment menu may intentionally select a zero-result value.
    // Disabled native facet inputs would otherwise disappear from FormData.
    if (param === availabilityParam || param === 'filter.v.availability') {
      input.disabled = false;
    }
    return input;
  }


  function ensureNativeHidden(param, value) {
    const nativeSort = param === 'sort_by' && getNativeForm()
      ? Array.from(getNativeForm().elements).find(function(field) {
          return field.name === param && field.type === 'hidden' && !field.dataset.flakeBridgeField;
        })
      : null;
    if (nativeSort) {
      nativeSort.value = value;
      removeNativeHidden(param);
      return nativeSort;
    }
    const form = getNativeForm();
    if (!form) return null;

    let input = form.querySelector(
      'input[type="hidden"][name="' + cssEscape(param) + '"][data-flake-bridge-field]'
    );

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = param;
      input.dataset.flakeBridgeField = 'true';
      form.appendChild(input);
    }

    input.value = value;
    return input;
  }


  function removeNativeHidden(param) {
    const form = getNativeForm();
    if (!form) return;

    Array.from(form.elements).forEach(function(input) {
      if (
        input.type === 'hidden' &&
        input.name === param &&
        input.dataset.flakeBridgeField
      ) {
        input.remove();
      }
    });
  }


  function setLoading(isLoading) {
    shop.classList.toggle('is-updating', isLoading);

    const grid = document.querySelector('#ProductGridContainer');
    if (grid) {
      grid.classList.toggle('flake-grid-is-updating', isLoading);
    }

    if (loadingFallbackTimer) {
      clearTimeout(loadingFallbackTimer);
    }

    if (isLoading) {
      loadingFallbackTimer = setTimeout(function() {
        setLoading(false);
      }, 3500);
    }
  }


  function installNativeFacetScrollGuard() {
    if (window.__flakeFacetScrollGuardInstalled) return;

    window.__flakeFacetScrollGuardInstalled = true;
    window.__flakeFacetSuppressScrollUntil = 0;

    const originalScrollIntoView = Element.prototype.scrollIntoView;
    const originalWindowScrollTo = window.scrollTo;
    const originalWindowScroll = window.scroll;
    const originalWindowScrollBy = window.scrollBy;
    const originalFocus = HTMLElement.prototype.focus;

    function shouldSuppress() {
      return Date.now() < (window.__flakeFacetSuppressScrollUntil || 0);
    }

    Element.prototype.scrollIntoView = function() {
      if (shouldSuppress()) {
        const grid = document.querySelector('#ProductGridContainer');
        const wrapper = document.querySelector('#ProductGridWrapper');

        if (
          this === grid ||
          this === wrapper ||
          grid?.contains(this) ||
          wrapper?.contains(this)
        ) {
          return;
        }
      }

      return originalScrollIntoView.apply(this, arguments);
    };

    /*
     * Some themes use window.scrollTo()/scroll() rather than
     * scrollIntoView() after a facet render. Block only those
     * programmatic calls during the short AJAX update window.
     * Normal wheel/touch scrolling is unaffected.
     */
    window.scrollTo = function() {
      if (shouldSuppress()) return;
      return originalWindowScrollTo.apply(window, arguments);
    };

    window.scroll = function() {
      if (shouldSuppress()) return;
      return originalWindowScroll.apply(window, arguments);
    };

    window.scrollBy = function() {
      if (shouldSuppress()) return;
      return originalWindowScrollBy.apply(window, arguments);
    };

    /* Prevent focus management inside the refreshed grid from scrolling. */
    HTMLElement.prototype.focus = function(options) {
      if (shouldSuppress()) {
        const grid = document.querySelector('#ProductGridContainer');
        const wrapper = document.querySelector('#ProductGridWrapper');

        if (
          this === grid ||
          this === wrapper ||
          grid?.contains(this) ||
          wrapper?.contains(this)
        ) {
          const safeOptions = Object.assign({}, options || {}, { preventScroll: true });
          return originalFocus.call(this, safeOptions);
        }
      }

      return originalFocus.apply(this, arguments);
    };
  }


  function suppressNativeFacetScroll(duration) {
    installNativeFacetScrollGuard();
    window.__flakeFacetSuppressScrollUntil = Date.now() + (duration || 1400);
  }


  /* =========================================================
     COLLECTION SWITCHING

     Named families come from the section's Shopify collection picker.
     Solids and All Blends use the existing type facet on All Flake.
     These are mutually exclusive browsing choices; color, size, and
     availability remain independent filters.
  ========================================================= */

  function normalizePath(pathname) {
    const normalized = String(pathname || '/').replace(/\/+$/, '');
    return normalized || '/';
  }


  function syncCollectionStates() {
    const currentPath = normalizePath(window.location.pathname);
    const selectedTypes = getParams().getAll(typeParam);

    document
      .querySelectorAll('[data-flake-collection-url]')
      .forEach(function(control) {
        let targetPath = '';

        try {
          targetPath = normalizePath(
            new URL(control.dataset.flakeCollectionUrl, window.location.origin).pathname
          );
        } catch (error) {
          targetPath = normalizePath(control.dataset.flakeCollectionUrl);
        }

        const controlType = control.dataset.flakeCollectionType;
        const typeMatches = controlType
          ? selectedTypes.length === 1 && selectedTypes[0] === controlType
          : selectedTypes.length === 0;
        const active = targetPath === currentPath && typeMatches;

        control.classList.toggle('is-active', active);
        control.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

    const selected = getSelectedCollectionControl();
    const currentLabel = shop.querySelector('[data-flake-collection-current]');
    if (currentLabel) {
      currentLabel.textContent = selected
        ? 'Collection: ' + selected.dataset.flakeCollectionLabel
        : 'Collection';
      currentLabel.closest('summary').classList.toggle('is-filtered', Boolean(selected));
    }
  }


  function getSelectedCollectionControl() {
    return shop.querySelector('[data-flake-collection-url].is-active:not([data-flake-collection-all])');
  }


  function selectCollection(control) {
    const targetUrl = buildCollectionTargetUrl(control.dataset.flakeCollectionUrl);
    targetUrl.searchParams.delete(typeParam);
    if (control.dataset.flakeCollectionType) {
      targetUrl.searchParams.set(typeParam, control.dataset.flakeCollectionType);
    }
    switchCollection(targetUrl.toString(), { exactUrl: true });
  }


  function buildCollectionTargetUrl(collectionUrl) {
    const url = new URL(collectionUrl, window.location.origin);
    const params = getParams();

    /* Never carry pagination or request-only Shopify params between collections. */
    params.delete('page');
    params.delete('section_id');
    params.delete('sections');
    params.delete('oseid');

    url.search = params.toString();
    url.hash = '';

    return url;
  }


  function updateResultsCopyFromDocument(doc) {
    const currentCopy = document.querySelector('[data-flake-results-copy]');
    const freshCopy = doc.querySelector('[data-flake-results-copy]');

    if (currentCopy && freshCopy) {
      currentCopy.innerHTML = freshCopy.innerHTML;

      if (freshCopy.dataset.allProductsCount) {
        currentCopy.dataset.allProductsCount = freshCopy.dataset.allProductsCount;
      }
    }

    /* Keep the section ID current so later facet updates can refresh the count. */
    const freshShop = doc.querySelector('[data-flake-shop]');
    if (freshShop && freshShop.dataset.sectionId) {
      shop.dataset.sectionId = freshShop.dataset.sectionId;
    }
  }


  function extractNativeProductCount(doc) {
    const selectors = [
      '#ProductCount',
      '[data-product-count]',
      '.product-count',
      '.collection-product-count',
      '.facets__product-count'
    ];

    for (const selector of selectors) {
      const node = doc.querySelector(selector);
      if (!node) continue;
      const match = node.textContent.match(/(\d[\d,]*)\s+products?/i);
      if (match) return match[1].replace(/,/g, '');
    }

    const wrapper = doc.querySelector('#ProductGridWrapper');
    if (wrapper) {
      const nodes = Array.from(wrapper.querySelectorAll('*'));
      for (const node of nodes) {
        const text = node.textContent.trim();
        const match = text.match(/^(\d[\d,]*)\s+products?$/i);
        if (match) return match[1].replace(/,/g, '');
      }
    }

    return null;
  }


  function updateResultsCopyFromDocument(doc) {
    const currentCopy = document.querySelector('[data-flake-results-copy]');
    const freshCopy = doc.querySelector('[data-flake-results-copy]');

    if (!currentCopy) return;

    if (freshCopy) {
      currentCopy.innerHTML = freshCopy.innerHTML;

      if (freshCopy.dataset.allProductsCount) {
        currentCopy.dataset.allProductsCount = freshCopy.dataset.allProductsCount;
      }
      return;
    }

    const nativeCount = extractNativeProductCount(doc);
    if (!nativeCount) return;

    const strong = currentCopy.querySelector('strong');
    const span = currentCopy.querySelector('span');

    if (strong) strong.textContent = nativeCount + ' products';
    if (span) span.textContent = 'matching your selections';
  }


  function replaceCollectionContentFromDocument(doc) {
    const currentFacet = document.querySelector('#FacetFiltersContainer');
    const freshFacet = doc.querySelector('#FacetFiltersContainer');
    const currentGrid = document.querySelector('#ProductGridContainer');
    const freshGrid = doc.querySelector('#ProductGridContainer');

    if (!currentFacet || !freshFacet || !currentGrid || !freshGrid) {
      return false;
    }

    /*
     * IMPORTANT: keep the existing ProductGridWrapper in place.
     * Target collection templates may include their own visible native
     * Filter / product-count / Sort toolbar inside that wrapper. Replacing
     * only the hidden facet form and actual grid keeps our custom toolbar
     * as the single storefront filtering experience.
     */
    currentFacet.replaceWith(freshFacet);
    currentGrid.replaceWith(freshGrid);

    updateResultsCopyFromDocument(doc);

    return true;
  }


  async function switchCollection(collectionUrl, options) {
    options = options || {};

    const targetUrl = options.exactUrl
      ? new URL(collectionUrl, window.location.origin)
      : buildCollectionTargetUrl(collectionUrl);

    const targetPath = normalizePath(targetUrl.pathname);
    const currentPath = normalizePath(window.location.pathname);

    /* Clicking the already-active collection should simply close menus. */
    if (
      targetPath === currentPath &&
      targetUrl.search === window.location.search &&
      options.force !== true
    ) {
      syncCollectionStates();
      return;
    }

    const requestNumber = ++collectionSwitchRequest;
    isSwitchingCollection = true;

    suppressNativeFacetScroll(2200);
    setLoading(true);

    try {
      const response = await fetch(targetUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error('Collection request failed: ' + response.status);
      }

      const html = await response.text();

      if (requestNumber !== collectionSwitchRequest) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');

      if (!replaceCollectionContentFromDocument(doc)) {
        throw new Error('Could not find the collection facet/product grid in the response.');
      }

      if (options.pushHistory !== false) {
        window.history.pushState(
          {},
          '',
          targetUrl.pathname + targetUrl.search
        );
      }

      renderedCollectionPath = targetUrl.pathname;

      /*
       * Rehydrate against the newly swapped native facet form, then sync
       * our custom controls without moving the shopper's viewport.
       */
      hydrateBridgeInputsFromUrl();
      syncCustomUI();
      syncCollectionStates();

    } catch (error) {
      console.warn('Could not switch flake collection with AJAX:', error);

      /* Graceful fallback: preserve the same target URL with a normal navigation. */
      window.location.href = targetUrl.toString();

    } finally {
      if (requestNumber === collectionSwitchRequest) {
        isSwitchingCollection = false;
        setLoading(false);
      }
    }
  }


  function triggerNativeUpdate(input) {
    if (!input) return false;

    /*
     * The theme's native facet component tries to scroll the viewport to
     * the refreshed product grid after filtering. Suppress that programmatic
     * scroll during the AJAX update so the shopper stays exactly where they are.
     */
    suppressNativeFacetScroll(1600);
    setLoading(true);

    input.dispatchEvent(new Event('change', {
      bubbles: true
    }));

    /*
     * The theme's facet-form updates ProductGridContainer and
     * browser history asynchronously. These delayed syncs are a
     * fallback in addition to the MutationObserver below.
     */
    scheduleSync(150);
    scheduleSync(500);

    return true;
  }


  function hydrateBridgeInputsFromUrl() {
    const form = getNativeForm();
    if (!form) return;

    const params = getParams();

    /* Preserve this alternate collection view through native AJAX/history updates. */
    const collectionView = params.get('view');
    if (collectionView) {
      ensureNativeHidden('view', collectionView);
    }

    /*
     * If a custom filter isn't rendered by the native facet UI,
     * preserve it as a checked hidden checkbox so the theme keeps
     * sending it with future AJAX requests.
     */
    const customPairs = new Map();

    document
      .querySelectorAll('[data-filter-param][data-filter-value]')
      .forEach(function(control) {
        const param = control.dataset.filterParam;
        const value = control.dataset.filterValue;

        if (!param || !value) return;

        customPairs.set(param + '||' + value, {
          param: param,
          value: value
        });
      });

    customPairs.forEach(function(pair) {
      const active = params.getAll(pair.param).includes(pair.value);
      const existing = findNativeInput(pair.param, pair.value);

      if (existing) {
        if (existing.type === 'checkbox' || existing.type === 'radio') {
          existing.checked = active;
        }
        return;
      }

      if (active) {
        const bridgeInput = ensureNativeCheckbox(pair.param, pair.value);
        if (bridgeInput) bridgeInput.checked = true;
      }
    });

    const sort = params.get('sort_by') || defaultSort;
    ensureNativeHidden('sort_by', sort);

    const priceMinValue = params.get('filter.v.price.gte');
    const priceMaxValue = params.get('filter.v.price.lte');

    if (priceMinValue) {
      ensureNativeHidden('filter.v.price.gte', priceMinValue);
    }

    if (priceMaxValue) {
      ensureNativeHidden('filter.v.price.lte', priceMaxValue);
    }
  }


  function setFlakeAvailability(value) {
    const params = getParams();
    params.delete(availabilityParam);
    params.delete('filter.v.availability');
    if (value) params.set(availabilityParam, value);
    if (value === 'In Stock') params.set('filter.v.availability', '1');

    const form = getNativeForm();
    if (!form) {
      fallbackNavigate(params);
      return;
    }

    let triggerInput = null;
    Array.from(form.elements).forEach(function(input) {
      if (input.name !== availabilityParam && input.name !== 'filter.v.availability') return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
        triggerInput = triggerInput || input;
      } else if (input.dataset.flakeBridgeField) {
        input.remove();
      }
    });
    if (value) {
      triggerInput = ensureNativeCheckbox(availabilityParam, value);
      triggerInput.checked = true;
      // Stocked fulfillment is distinct from supplier products with placeholder inventory.
      if (value === 'In Stock') {
        const inventoryInput = ensureNativeCheckbox('filter.v.availability', '1');
        inventoryInput.checked = true;
      }
    }
    triggerNativeUpdate(triggerInput || form.querySelector('input, select'));
  }

  function toggleFilter(param, value) {
    if (param === availabilityParam) {
      setFlakeAvailability(getParams().getAll(param).includes(value) ? '' : value);
      return;
    }
    const input = ensureNativeCheckbox(param, value);

    if (!input) {
      const params = getParams();
      const currentValues = params.getAll(param);

      params.delete(param);

      if (currentValues.includes(value)) {
        currentValues
          .filter(function(item) { return item !== value; })
          .forEach(function(item) { params.append(param, item); });
      } else {
        currentValues.forEach(function(item) {
          params.append(param, item);
        });
        params.append(param, value);
      }

      fallbackNavigate(params);
      return;
    }

    input.checked = !input.checked;
    triggerNativeUpdate(input);
  }


  /* =========================================================
     CUSTOM UI SYNC
  ========================================================= */

  function matchingControlLabel(param, value) {
    const controls = Array.from(
      document.querySelectorAll('[data-filter-param][data-filter-value]')
    );

    const control = controls.find(function(element) {
      return (
        element.dataset.filterParam === param &&
        element.dataset.filterValue === value
      );
    });

    if (control && control.dataset.filterLabel) {
      return control.dataset.filterLabel;
    }

    const specialLabels = {
      '1/4"': '1/4" Flake',
      '1/8"': '1/8" Flake',
      '1/16"': '1/16" Flake',
      '1': 'In Stock'
    };

    return specialLabels[value] || value;
  }


  function syncControlStates() {
    const params = getParams();

    document
      .querySelectorAll('[data-filter-param][data-filter-value]')
      .forEach(function(control) {
        const param = control.dataset.filterParam;
        const value = control.dataset.filterValue;
        const active = control.hasAttribute('data-flake-availability') && !value
          ? !params.has(availabilityParam)
          : params.getAll(param).includes(value);
        const nativeInput = findNativeInput(param, value);

        control.classList.toggle('is-active', active);
        control.setAttribute('aria-pressed', active ? 'true' : 'false');

        /*
         * Mirror Shopify's availability state when this value is
         * actually present in the native facet form.
         */
        if (nativeInput && !nativeInput.dataset.flakeBridge && !control.hasAttribute('data-flake-availability')) {
          control.disabled = nativeInput.disabled;
          control.classList.toggle('is-disabled', nativeInput.disabled);

          const nativeLabel = nativeInput.labels && nativeInput.labels.length
            ? nativeInput.labels[0]
            : null;

          if (nativeLabel) {
            const tooltip = nativeLabel.querySelector('.tooltip');
            if (tooltip && tooltip.textContent.trim()) {
              control.setAttribute('aria-label', tooltip.textContent.trim());
            }
          }
        }
      });
  }


  function syncAvailabilityLabel() {
    const value = getParams().get(availabilityParam);
    document.querySelectorAll('[data-flake-availability-label]').forEach(function(label) {
      label.textContent = value ? 'Availability: ' + value : 'Availability';
    });
  }

  function rebuildActiveFilters() {
    const holder = document.querySelector('[data-active-filters]');
    if (!holder) return 0;

    holder.querySelectorAll('.flake-active-chip:not([data-demo-chip])').forEach(function(chip) {
      chip.remove();
    });

    const params = getParams();
    const seen = new Set();
    let activeCount = 0;
    const selectedCollection = getSelectedCollectionControl();
    const allCollections = shop.querySelector('[data-flake-collection-all]');

    if (selectedCollection && allCollections) {
      activeCount++;
      const label = selectedCollection.dataset.flakeCollectionLabel;
      const collectionChip = document.createElement('button');
      collectionChip.type = 'button';
      collectionChip.className = 'flake-active-chip';
      collectionChip.textContent = 'Collection: ' + label + ' ';
      collectionChip.setAttribute('aria-label', 'Remove ' + label + ' collection');
      const removeIcon = document.createElement('span');
      removeIcon.setAttribute('aria-hidden', 'true');
      removeIcon.textContent = '×';
      collectionChip.appendChild(removeIcon);
      collectionChip.addEventListener('click', function() {
        selectCollection(allCollections);
      });
      holder.appendChild(collectionChip);
    }

    params.forEach(function(value, param) {
      if (!param.startsWith('filter.')) return;
      if (param === typeParam && selectedCollection?.dataset.flakeCollectionType) return;
      if (param === 'filter.v.price.gte' || param === 'filter.v.price.lte') return;
       if (param === 'filter.v.availability' && params.get(availabilityParam) === 'In Stock') return;

      const key = param + '||' + value;
      if (seen.has(key)) return;
      seen.add(key);
      activeCount++;

      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'flake-active-chip';
      chip.innerHTML =
        matchingControlLabel(param, value) +
        ' <span aria-hidden="true">×</span>';

      chip.addEventListener('click', function() {
        toggleFilter(param, value);
      });

      holder.appendChild(chip);
    });

    const priceMin = params.get('filter.v.price.gte');
    const priceMax = params.get('filter.v.price.lte');

    if (priceMin || priceMax) {
      activeCount++;

      const priceChip = document.createElement('button');
      priceChip.type = 'button';
      priceChip.className = 'flake-active-chip';
      priceChip.innerHTML =
        '$' + (priceMin || '0') + '–$' + (priceMax || 'Any') +
        ' <span aria-hidden="true">×</span>';

      priceChip.addEventListener('click', function() {
        clearPrice();
      });

      holder.appendChild(priceChip);
    }

    return activeCount;
  }


  function updateFilterCountBadge(realCount) {
    const countBadge = document.querySelector('[data-filter-count]');
    if (!countBadge) return;

    if (typeof realCount !== 'number') {
      realCount = getActiveRealFilterCount();
    }

    const total = realCount;

    countBadge.hidden = total === 0;
    countBadge.textContent = total ? total : '';
  }


  function getActiveRealFilterCount() {
    const params = getParams();
    const seen = new Set();

    params.forEach(function(value, param) {
      if (!param.startsWith('filter.')) return;

      if (param === 'filter.v.price.gte' || param === 'filter.v.price.lte') {
        seen.add('price');
      } else {
        seen.add(param + '||' + value);
      }
    });

    return seen.size;
  }


  function syncSortAndPrice() {
    const params = getParams();
    const sortSelect = document.querySelector('[data-flake-sort]');
    const priceMin = document.querySelector('[data-price-min]');
    const priceMax = document.querySelector('[data-price-max]');

    if (sortSelect) {
      sortSelect.value = params.get('sort_by') || defaultSort;
    }

    if (priceMin) {
      priceMin.value = params.get('filter.v.price.gte') || '';
    }

    if (priceMax) {
      priceMax.value = params.get('filter.v.price.lte') || '';
    }
  }


  function syncResultsCopy() {
    const copy = document.querySelector('[data-flake-results-copy]');
    if (!copy) return;

    const strong = copy.querySelector('strong');
    const span = copy.querySelector('span');
    const hasFilters = getActiveRealFilterCount() > 0;

    if (!strong || !span) return;

    /*
     * When filters are active, leave the current server-rendered count in
     * place until refreshResultsCopyFromSection() replaces it with the
     * exact filtered count. Do not replace it with a generic status label.
     */
    if (hasFilters) return;

    const allProducts = copy.dataset.allProductsCount;

    if (allProducts) {
      strong.textContent = allProducts + ' floor flake options';
    }

    span.textContent = 'Find the right color, texture, and style.';
  }


  async function refreshResultsCopyFromSection() {
    const shopElement = document.querySelector('[data-flake-shop]');
    const currentCopy = document.querySelector('[data-flake-results-copy]');

    if (!shopElement || !currentCopy) return;

    const sectionId = shopElement.dataset.sectionId;
    if (!sectionId) return;

    const requestNumber = ++resultsCopyRequest;

    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return;

      const html = await response.text();
      if (requestNumber !== resultsCopyRequest) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshCopy = doc.querySelector('[data-flake-results-copy]');

      if (freshCopy) {
        currentCopy.innerHTML = freshCopy.innerHTML;

        if (freshCopy.dataset.allProductsCount) {
          currentCopy.dataset.allProductsCount = freshCopy.dataset.allProductsCount;
        }
        return;
      }

      const nativeCount = extractNativeProductCount(doc);
      if (!nativeCount) return;

      const strong = currentCopy.querySelector('strong');
      const span = currentCopy.querySelector('span');

      if (strong) strong.textContent = nativeCount + ' products';
      if (span) span.textContent = 'matching your selections';
    } catch (error) {
      console.warn('Could not refresh filtered result count:', error);
    }
  }


  function syncCustomUI() {
    hydrateBridgeInputsFromUrl();
    syncControlStates();
    syncAvailabilityLabel();
    syncCollectionStates();

    const realCount = rebuildActiveFilters();
    updateFilterCountBadge(realCount);
    syncSortAndPrice();
    syncResultsCopy();
    setLoading(false);
  }


  function scheduleSync(delay) {
    if (syncTimer) clearTimeout(syncTimer);

    syncTimer = setTimeout(function() {
      syncCustomUI();
    }, typeof delay === 'number' ? delay : 100);
  }


  /* =========================================================
     COLLECTION CONTROLS
  ========================================================= */

  document.addEventListener('click', function(event) {
    const control = event.target.closest('[data-flake-collection-url]');

    if (!control) return;

    event.preventDefault();

    const quickFilter = control.closest('.flake-quick-filter');
    if (quickFilter) {
      quickFilter.removeAttribute('open');
    }

    closeDrawer();

    selectCollection(control);
  });


  /* =========================================================
     REAL SEARCH & DISCOVERY FILTER CONTROLS
  ========================================================= */

  document.addEventListener('click', function(event) {
    const control = event.target.closest(
      '[data-flake-shop] [data-filter-param][data-filter-value], ' +
      '[data-filter-drawer] [data-filter-param][data-filter-value]'
    );

    if (!control) return;
    if (control.disabled) return;

    event.preventDefault();

    /*
     * On mobile the quick-filter menu is a full-width popover. Close it
     * immediately after a choice so the updated results/state are visible.
     */
    const quickFilter = control.closest('.flake-quick-filter');
    if (quickFilter) {
      quickFilter.removeAttribute('open');
    }

    if (control.hasAttribute('data-flake-availability')) {
      setFlakeAvailability(control.dataset.filterValue);
    } else {
      toggleFilter(control.dataset.filterParam, control.dataset.filterValue);
    }
  });



  /* =========================================================
     CLEAR COLOR
  ========================================================= */

  document.querySelectorAll('[data-clear-color]').forEach(function(button) {
    button.addEventListener('click', function() {
      const colorParam = this.dataset.filterParam;
      const form = getNativeForm();

      if (!colorParam || !form) {
        const params = getParams();
        if (colorParam) params.delete(colorParam);
        fallbackNavigate(params);
        return;
      }

      const inputs = Array.from(form.elements).filter(function(input) {
        return input.name === colorParam;
      });

      let triggerInput = null;

      inputs.forEach(function(input) {
        if ((input.type === 'checkbox' || input.type === 'radio') && input.checked) {
          input.checked = false;
          if (!triggerInput) triggerInput = input;
        }
      });

      if (!triggerInput) {
        triggerInput = inputs[0] || ensureNativeCheckbox(colorParam, '__flake_noop__');
      }

      if (triggerInput && triggerInput.value === '__flake_noop__') {
        triggerInput.checked = false;
      }

      triggerNativeUpdate(triggerInput);
    });
  });


  /* =========================================================
     CLEAR ALL
  ========================================================= */

  document.querySelectorAll('[data-clear-all]').forEach(function(button) {
    button.addEventListener('click', function() {
      const allCollections = shop.querySelector('[data-flake-collection-all]');
      if (getSelectedCollectionControl() && allCollections) {
        const targetUrl = buildCollectionTargetUrl(allCollections.dataset.flakeCollectionUrl);
        Array.from(targetUrl.searchParams.keys()).forEach(function(param) {
          if (param.startsWith('filter.') || param === 'page') targetUrl.searchParams.delete(param);
        });
        closeDrawer();
        switchCollection(targetUrl.toString(), { exactUrl: true });
        return;
      }

      const form = getNativeForm();

      if (!form) {
        const params = getParams();
        Array.from(params.keys()).forEach(function(param) {
          if (param.startsWith('filter.') || param === 'page') params.delete(param);
        });
        const sort = getParams().get('sort_by');
        if (sort) params.set('sort_by', sort);
        fallbackNavigate(params);
        return;
      }

      const sort = getParams().get('sort_by');
      let triggerInput = null;

      Array.from(form.elements).forEach(function(input) {
        if (!input.name) return;

        if (input.name.startsWith('filter.')) {
          if (input.type === 'checkbox' || input.type === 'radio') {
            if (input.checked) {
              input.checked = false;
              if (!triggerInput) triggerInput = input;
            }
          } else if (input.dataset.flakeBridgeField) {
            input.remove();
          }
        }
      });

      removeNativeHidden('filter.v.price.gte');
      removeNativeHidden('filter.v.price.lte');

      if (sort) {
        ensureNativeHidden('sort_by', sort);
      }

      if (!triggerInput) {
        triggerInput = form.querySelector('input, select');
      }

      updateFilterCountBadge(0);
      triggerNativeUpdate(triggerInput);
    });
  });


  /* =========================================================
     SORT
  ========================================================= */

  const sortSelect = document.querySelector('[data-flake-sort]');

  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      hydrateBridgeInputsFromUrl();

      const sortInput = ensureNativeHidden('sort_by', this.value);

      if (!triggerNativeUpdate(sortInput)) {
        const params = getParams();
        params.set('sort_by', this.value);
        fallbackNavigate(params);
      }
    });
  }


  /* =========================================================
     PRICE
  ========================================================= */

  const priceMin = document.querySelector('[data-price-min]');
  const priceMax = document.querySelector('[data-price-max]');
  const priceApply = document.querySelector('[data-price-apply]');


  function clearPrice() {
    const form = getNativeForm();

    if (!form) {
      const params = getParams();
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      fallbackNavigate(params);
      return;
    }

    removeNativeHidden('filter.v.price.gte');
    removeNativeHidden('filter.v.price.lte');

    const triggerInput = form.querySelector('input, select');
    triggerNativeUpdate(triggerInput);
  }


  if (priceApply) {
    priceApply.addEventListener('click', function() {
      hydrateBridgeInputsFromUrl();

      const form = getNativeForm();

      if (!form) {
        const params = getParams();

        if (priceMin && priceMin.value) {
          params.set('filter.v.price.gte', priceMin.value);
        } else {
          params.delete('filter.v.price.gte');
        }

        if (priceMax && priceMax.value) {
          params.set('filter.v.price.lte', priceMax.value);
        } else {
          params.delete('filter.v.price.lte');
        }

        fallbackNavigate(params);
        return;
      }

      let triggerInput = null;

      if (priceMin && priceMin.value) {
        triggerInput = ensureNativeHidden('filter.v.price.gte', priceMin.value);
      } else {
        removeNativeHidden('filter.v.price.gte');
      }

      if (priceMax && priceMax.value) {
        triggerInput = ensureNativeHidden('filter.v.price.lte', priceMax.value) || triggerInput;
      } else {
        removeNativeHidden('filter.v.price.lte');
      }

      if (!triggerInput) {
        triggerInput = form.querySelector('input, select');
      }

      triggerNativeUpdate(triggerInput);
    });
  }


  /* =========================================================
     DRAWER
  ========================================================= */

  function openDrawer() {
    if (!drawer || !overlay) return;
    closeQuickFilters();

    drawer.classList.add('is-open');
    overlay.classList.add('is-open');

    /*
     * Class-based scroll locking works more reliably with iOS Safari than
     * mutating only documentElement.style.overflow. The drawer body remains
     * its own touch-scrollable region via CSS.
     */
    document.documentElement.classList.add('flake-filter-drawer-open');
    document.body.classList.add('flake-filter-drawer-open');
  }


  function closeDrawer() {
    if (!drawer || !overlay) return;

    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('flake-filter-drawer-open');
    document.body.classList.remove('flake-filter-drawer-open');
  }


  document.querySelectorAll('[data-open-filters]').forEach(function(button) {
    button.addEventListener('click', openDrawer);
  });


  document.querySelectorAll('[data-close-filters]').forEach(function(button) {
    button.addEventListener('click', closeDrawer);
  });


  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }


  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const openFilter = shop.querySelector('.flake-quick-filter[open]');
      if (openFilter) openFilter.querySelector('summary').focus();
      closeQuickFilters();
      closeDrawer();
    }
  });


  /* =========================================================
     DRAWER ACCORDIONS
  ========================================================= */

  document.querySelectorAll('.flake-drawer-heading').forEach(function(button) {
    button.addEventListener('click', function() {
      const group = this.closest('.flake-drawer-group');
      const options = group.querySelector('.flake-drawer-options, .flake-price-fields');
      const indicator = this.lastElementChild;

      if (!options) return;

      const closed = options.style.display === 'none';

      options.style.display = closed ? '' : 'none';
      indicator.textContent = closed ? '−' : '+';
    });
  });


  /* =========================================================
     CLOSE OTHER QUICK FILTER MENUS
  ========================================================= */

  const quickFilters = shop.querySelectorAll('.flake-quick-filter');
  const quickFilterStrip = shop.querySelector('.flake-filter-toolbar-left');

  function closeQuickFilters(except) {
    quickFilters.forEach(function(detail) {
      if (detail !== except) detail.removeAttribute('open');
    });
  }

  function positionQuickFilter(detail) {
    const menu = detail.querySelector('.flake-quick-menu');
    if (!menu) return;
    if (!window.matchMedia('(max-width: 989px)').matches) {
      ['top', 'left', 'width', 'max-height'].forEach(function(property) {
        menu.style.removeProperty(property);
      });
      return;
    }

    const anchor = detail.querySelector('summary').getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const gutter = 12;
    const gap = 8;
    const below = Math.max(0, viewportHeight - anchor.bottom - gap - gutter);
    const above = Math.max(0, anchor.top - gap - gutter);
    const useAbove = below < 220 && above > below;
    const maxHeight = Math.min(360, useAbove ? above : below);
    menu.style.left = gutter + 'px';
    menu.style.width = (document.documentElement.clientWidth - gutter * 2) + 'px';
    menu.style.maxHeight = maxHeight + 'px';
    menu.style.top = (useAbove
      ? Math.max(gutter, anchor.top - gap - Math.min(menu.scrollHeight, maxHeight))
      : anchor.bottom + gap) + 'px';
  }

  quickFilters.forEach(function(detail) {
    detail.addEventListener('toggle', function() {
      if (!detail.open) return;
      closeQuickFilters(detail);
      positionQuickFilter(detail);
    });
  });

  document.addEventListener('pointerdown', function(event) {
    if (!shop.isConnected) return;
    const openFilter = shop.querySelector('.flake-quick-filter[open]');
    if (openFilter && !openFilter.contains(event.target)) closeQuickFilters();
  });

  if (quickFilterStrip) {
    quickFilterStrip.addEventListener('scroll', function() {
      closeQuickFilters();
    }, { passive: true });
  }

  function repositionOpenFilter() {
    if (!shop.isConnected) return;
    const openFilter = shop.querySelector('.flake-quick-filter[open]');
    if (openFilter) positionQuickFilter(openFilter);
  }
  window.addEventListener('resize', repositionOpenFilter);
  window.addEventListener('scroll', repositionOpenFilter, { passive: true });


  /* =========================================================
     WATCH NATIVE FACET AJAX UPDATES
  ========================================================= */

  const nativeUpdateObserver = new MutationObserver(function(mutations) {
    if (isSwitchingCollection) return;

    const relevant = mutations.some(function(mutation) {
      const target = mutation.target;

      if (target.nodeType === 1) {
        if (
          target.id === 'FacetFiltersContainer' ||
          target.id === 'ProductGridContainer' ||
          target.closest?.('#FacetFiltersContainer, #ProductGridContainer')
        ) {
          return true;
        }
      }

      return Array.from(mutation.addedNodes).some(function(node) {
        if (node.nodeType !== 1) return false;

        return (
          node.id === 'FacetFiltersContainer' ||
          node.id === 'ProductGridContainer' ||
          node.querySelector?.('#FacetFiltersContainer, #ProductGridContainer')
        );
      });
    });

    if (relevant) {
      scheduleSync(120);

      /*
       * Our custom filter section is outside the product-grid section, so
       * Shopify's native AJAX does not re-render its Liquid result count.
       * Re-render only this lightweight section and copy the exact count.
       */
      setTimeout(refreshResultsCopyFromSection, 140);
    }
  });

  nativeUpdateObserver.observe(document.body, {
    childList: true,
    subtree: true
  });


  window.addEventListener('popstate', function() {
    const currentPath = normalizePath(window.location.pathname);
    const renderedPath = normalizePath(renderedCollectionPath);

    if (currentPath !== renderedPath) {
      switchCollection(window.location.href, {
        pushHistory: false,
        exactUrl: true,
        force: true
      });
      return;
    }

    scheduleSync(50);
  });


  /* Initial state. Featured order is fetched by Shopify before pagination. */
  syncCustomUI();
  if (!getParams().has('sort_by') || getParams().getAll('sort_by').length > 1) {
    const featuredUrl = new URL(window.location.href);
    featuredUrl.searchParams.set('sort_by', getParams().get('sort_by') || defaultSort);
    switchCollection(featuredUrl.toString(), { exactUrl: true, force: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFlakeShopFilter);
} else {
  initFlakeShopFilter();
}

document.addEventListener('shopify:section:load', function (event) {
  if (event.target && event.target.querySelector('[data-flake-shop]')) {
    initFlakeShopFilter();
  }
});

})();
